'use client'

// import React, { createContext, use, useCallback, useState } from 'react'
import { createContext, use } from 'react'

// import canUseDOM from '@/utilities/canUseDOM'

import type { Theme } from '@/providers/Theme/types'

interface ContextType {
  headerTheme?: Theme | null
  setHeaderTheme: (theme: Theme | null) => void
}

const initialContext: ContextType = {
  headerTheme: undefined,
  setHeaderTheme: () => null,
}

const HeaderThemeContext = createContext(initialContext)

// const HeaderThemeProvider = ({ children }: { children: React.ReactNode }) => {
//   const [headerTheme, setThemeState] = useState<Theme | undefined | null>(
//     canUseDOM ? (document.documentElement.getAttribute('data-theme') as Theme) : undefined,
//   )

//   const setHeaderTheme = useCallback((themeToSet: Theme | null) => {
//     setThemeState(themeToSet)
//   }, [])

//   return <HeaderThemeContext value={{ headerTheme, setHeaderTheme }}>{children}</HeaderThemeContext>
// }

export const useHeaderTheme = (): ContextType => use(HeaderThemeContext)
